export const theme = {
  breakpoints: ["480px", "768px", "992px", "1200px", "1800px"]
};
